import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Challengespoint() {
  return (
    <section className="scope_rev p-100 text_white bg_purple_color">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="goals_img">
              <StaticImage
                src="../../../images/case-studies/rev-coin/Problem_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={528}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>
              The
              <span style={{ color: "#E8E751" }}> Problem</span>
            </h2>
            <div className="scope_content">
              <p>
                Traditional employee retention and loyalty programs regularly
                face substantial challenges that can delay their effectiveness
                in nurturing employee engagement and loyalty.
              </p>
              <p>
                Inadequate transparency, limited incentives, and intricacies in
                managing employee benefits are among the major issues that
                requires to be solved.
              </p>
              <p>
                Firstly, inadequate transparency within traditional loyalty
                programs can develop a sense of uncertainty and suspicion among
                employees.
              </p>
              <p>
                Employees may have trouble considering the value of their shares
                or rewards, as well as how they can access or utilize them.
              </p>
              <p>
                This absence of transparency can lead to hindrance and a
                perception that the program's benefits are not perceptible or
                meaningful.
              </p>
              <p>
                Secondly, inadequate incentives within traditional programs may
                fail to inspire employees to energetically participate.
              </p>
              <p>
                If the rewards are professed as insignificant or inaccessible,
                employees may become detached and lose interest in the program.
              </p>
              <p>
                This can result in reduced employee satisfaction and a decreased
                sense of loyalty towards the company.
              </p>
              <p>
                Moreover, intricacies in managing employee benefits can enhance
                complexity and misperception to the process.
              </p>
              <p>
                Employees may come across challenges when trying to steer
                through multiple systems or platforms to access their benefits
                or understand their options.
              </p>
              <p>
                This lack of straightforwardness and ease-of-use can dissuade
                employees from dynamically engaging with the program and bound
                their ability to fully utilize its advantages.
              </p>
              <p>
                Also, the absence of a fused digital currency or platform
                further obscures the process of utilizing loyalty program
                benefits.
              </p>
              <p>
                Without a modernized and centralized system, employees may face
                barriers in tracking, managing, and trading their rewards.
              </p>
              <p>
                This can delay their ability to fully employ the benefits and
                stem value from the program.
              </p>
              <p>
                Solving these challenges is critical for fostering a positive
                work culture and enhancing employee loyalty.
              </p>
              <p>
                By improving transparency, streamlining processes, and offering
                meaningful incentives, we can develop a loyalty program that
                effectively engages employees, enhances their satisfaction, and
                nurtures long-term commitment to the organization.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Challengespoint;
